import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { Offer } from '@wwt/entities/search-response'

import { formatDate } from '../utils/formatDate.ts'
import { getRoomOfferPathToOfferId } from '../utils/getRoomOfferPathToOfferId.ts'

export const useOfferCardReservation = (
	offer: Offer,
	onLinkClickCallback: () => void
) => {
	const { t } = useTranslation()

	const roomOfferPath = getRoomOfferPathToOfferId(offer.IDs.wwtOfferId)

	const onLinkClick = useCallback(
		(event: React.MouseEvent<HTMLDivElement>) => {
			const isLinkElementClicked = event.target instanceof HTMLAnchorElement

			if (!isLinkElementClicked) return

			onLinkClickCallback?.()
		},
		[onLinkClickCallback]
	)

	return {
		roomOfferPath,
		price: t('price.base', {
			value: offer.price.totalPrice(true)
		}),
		country: offer.hotelStatic.geolocation.address.country,
		dates: `${formatDate(offer.roomDynamic.checkIn)} - ${formatDate(
			offer.roomDynamic.checkOut
		)}`,
		onLinkClick
	}
}
